import Immutable from 'immutable';
import {
  FLAG_GETTING_DRIVER_CONTRACT_TYPES,
  GET_DRIVER_CONTRACT_TYPES,
  CLEAR_DRIVER_CONTRACT_TYPES,
  FLAG_DRIVER_CONTRACT_TYPE_ACTIVITY,
  CLEAR_DRIVER_CONTRACT_TYPE,
  GET_DRIVER_CONTRACT_TYPE,
} from '../../../actions/types/traffic';
import { COLLECTION_SHAPE } from '../../../config/shapes';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_DRIVER_CONTRACT_TYPES:
      return state.setIn(['all', 'loading'], payload);
    case GET_DRIVER_CONTRACT_TYPES:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_DRIVER_CONTRACT_TYPES:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_DRIVER_CONTRACT_TYPE_ACTIVITY:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_DRIVER_CONTRACT_TYPE:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_DRIVER_CONTRACT_TYPE:
      return state.setIn(['current'], INITIAL_STATE.getIn(['current']));
    default:
      return state;
  }
};
